import { render, staticRenderFns } from "./ArtworkMainImage.vue?vue&type=template&id=7208e673&"
import script from "./ArtworkMainImage.vue?vue&type=script&lang=js&"
export * from "./ArtworkMainImage.vue?vue&type=script&lang=js&"
import style0 from "./ArtworkMainImage.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports